module.exports = __webpack_public_path__ + "media/src/website/images/locations/going/going_01-b6d8e0b81ae73fae9f5165b1582a9b7c.jpg";